module.exports = "<div class=\"modal-body content-centered\">\n    <h3 class=\"title\">{{ title }}</h3>\n    <p>{{ message }}</p>\n\n    <button (click)=\"closeModal()\" class=\"btn btn-default\">Okay</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/common/alert-modal/alert-modal.component.html
// module id = ./web/modern/components/common/alert-modal/alert-modal.component.html
// module chunks = 0